import { watch, onMounted, onUnmounted } from "vue";

// State
import {
  activeTab,
  dateRange,
  isConnected,
  isAuthorized,
  hasPropertyId,
  processedData,
  realtimeData,
  loading,
  realtimeLoading,
  realtimeInterval,
  authMessage,
  visitorChartData,
  countryChartData,
  deviceChartData,
  sourceTableData,
  realtimeTimelineData,
  realtimeCountryData,
  realtimeDeviceData
} from './state';

// Methods
import { switchTab } from './methods/switchTab';
import { clearDateRange } from './methods/clearDateRange';
import { navigateToIntegrations } from './methods/navigateToIntegrations';
import { fetchAnalyticsData } from './methods/fetchAnalyticsData';
import { fetchRealtimeData } from './methods/fetchRealtimeData';
import { checkPropertyLinked } from './methods/checkPropertyLinked';
import { handleDateRangeChange } from './methods/handleDateRangeChange';
import { revokeInvalidAccount } from './methods/revokeInvalidAccount';

// Services
import services from '../../services';

export default function useAnalytics(assetId) {
  // Tarih aralığı değişikliğini izle
  watch(dateRange, () => {
    handleDateRangeChange(assetId);
  }, { deep: true });

  // Component mount edildiğinde
  onMounted(async () => {
    // Google entegrasyon ve mülk durumunu kontrol et
    await checkPropertyLinked(assetId);
  });

  // Component unmount edildiğinde
  onUnmounted(() => {
    // Interval'ı temizle
    if (realtimeInterval.value) {
      clearInterval(realtimeInterval.value);
      realtimeInterval.value = null;
    }
  });
  
  return {
    // State
    activeTab,
    dateRange,
    isConnected,
    isAuthorized,
    hasPropertyId,
    processedData,
    realtimeData,
    loading,
    realtimeLoading,
    authMessage,
    
    // Computed properties
    visitorChartData,
    countryChartData,
    deviceChartData,
    sourceTableData,
    realtimeTimelineData,
    realtimeCountryData,
    realtimeDeviceData,
    
    // Formatters
    formatBounceRate: services.analytics.formatBounceRate,
    
    // Methods
    switchTab: (tab) => switchTab(tab, isConnected.value, assetId),
    clearDateRange: () => clearDateRange(assetId),
    navigateToIntegrations,
    checkPropertyLinked: () => checkPropertyLinked(assetId),
    revokeInvalidAccount: () => revokeInvalidAccount(assetId),
  };
}